import { createContext } from 'react';

export const FormSurfaceContext = createContext(false);
